import { backgroundImageForUrl } from '@shared/utils/style/backgroundImage';

import React from 'react';
import { addRendition } from '@shared/utils/photoRendition';
import type { AuxPhoto } from '../../../AuxFrame/AuxFrame.types';

export const CoverPhoto: React.FC<{ photo: AuxPhoto }> = ({ photo }) => {
  return (
    <>
      <div
        style={{
          position: 'absolute',
          pointerEvents: 'none',
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          height: '100vh',
          backgroundImage: backgroundImageForUrl(addRendition({ url: photo.url, renditionSize: 'xlarge' })),
          backgroundSize: 'cover',
          backgroundPosition: `${photo.layout.alignX} ${photo.layout.alignY}`,
          backgroundRepeat: 'no-repeat',
        }}
      />
    </>
  );
};

CoverPhoto.displayName = 'CoverPhoto';
